import fetchServer from "../fetchServer";

/** The booking list leaves conversation as ids. The ticket read is the one
 * that fills flightBooking.conversation with the actual messages. */
export default async function getTicketConversation(id) {
  var result = { return: 0, msg: "Failed fetching ticket messages", data: [] };

  await fetchServer({
    method: "GET",
    url: `/product/v1/ticket/queue/${id}?populate=flightBooking&populate=flightBooking.conversation`,
  })
    .then((res) => {
      if (res) {
        if (res.status === 200) {
          result = { return: 1, msg: "Successfull", data: res.data.data };
        } else if (res?.data?.error) result["msg"] = res.data.error;
      }
    })
    .catch((err) => {
      console.log(err.message, err);
      if (err.message === "Network Error!") {
        result["msg"] = "Network Error!";
        result["error"] = "Please check your connection.";
      }
    });

  return result;
}
